// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1":"fceb1c30","430":"9fa279f9","716":"a19b77ef","981":"fceb1c30"}[chunkId] + ".chunk.css";
};